// World-space map labels (sun / planet names), on imperial-box-ui + imperial-text-base.
// A label is a small semi-transparent rounded box hosting a centered text; depthTest is off
// so it draws over the map. Billboarding + constant-screen-size scaling is done by the entity
// system that owns game.labels.
import { createBox, text, loadFontFamily } from 'imperial-lib';

const makeBox = createBox({ text });
// Map labels use the body family (Play), from the CDN — same as the GUI's text.
const fontReady = loadFontFamily('https://cdn.worldapi.org/imperial-text-base/google/play/font.json');

export async function createLabel(str) {
	const font = await fontReady;
	const label = makeBox({
		backgroundColor: [0, 0, 0, 0.66],
		borderRadii: [3, 3, 3, 3],
		padding: [3, 5, 3, 5],   // top, right, bottom, left
		text: str,
		font,
		fontSize: 14,
		color: [1, 1, 1],
		textAlign: 'center',
		textWrap: false,
	});
	// Draw over the map regardless of depth (box surface + the text mesh).
	label.material.depthTest = false;
	const tm = label._text?.mesh;
	if (tm) tm.material.depthTest = false;
	return label;
}
